export default __webpack_public_path__ + "static/compareItemImg5-9f29afda383ef66a52acbe9d3fb05f4d.png";